import { render, staticRenderFns } from "./NotificationsOverlay.vue?vue&type=template&id=53065994&scoped=true&"
import script from "./NotificationsOverlay.vue?vue&type=script&lang=js&"
export * from "./NotificationsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsOverlay.vue?vue&type=style&index=0&id=53065994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53065994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53065994')) {
      api.createRecord('53065994', component.options)
    } else {
      api.reload('53065994', component.options)
    }
    module.hot.accept("./NotificationsOverlay.vue?vue&type=template&id=53065994&scoped=true&", function () {
      api.rerender('53065994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/NotificationsOverlay.vue"
export default component.exports